import { isDefined } from '@/utils/isDefined';

export const assertDefined = <DefinedType>(unknown: DefinedType | null | undefined) => {
  if (!isDefined(unknown)) {
    throw new Error('Unexpected undefined value');
  }

  return unknown;
};
